import React from "react";
import { useLang } from "@/context/LanguageContext";
import { CheckCircle2, Clock, MessageSquareQuote } from "lucide-react";

const CONFIG = {
  to_verify:           { color: "#A96B18", bg: "#FBEDD6", icon: Clock,              key: "to_verify" },
  testimony_confirmed: { color: "#3E6B8A", bg: "#E1ECF3", icon: MessageSquareQuote, key: "testimony_confirmed" },
  cross_validated:     { color: "#2C4230", bg: "#E6EFE7", icon: CheckCircle2,       key: "cross_validated" },
};

export const VerificationBadge = ({ status = "to_verify", size = "sm", withLabel = true }) => {
  const { t } = useLang();
  const cfg = CONFIG[status] || CONFIG.to_verify;
  const Icon = cfg.icon;
  const padding = size === "lg" ? "px-3 py-1" : "px-2 py-0.5";
  const text = size === "lg" ? "text-xs" : "text-[10px]";
  const iconSize = size === "lg" ? "w-3.5 h-3.5" : "w-3 h-3";

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border ${padding} ${text} font-semibold uppercase tracking-wider`}
      style={{ background: cfg.bg, color: cfg.color, borderColor: cfg.color }}
      data-testid={`verification-badge-${status}`}
    >
      <Icon className={iconSize} />
      {withLabel && <span>{t(cfg.key)}</span>}
    </span>
  );
};

export default VerificationBadge;
